import axios from 'axios'
const endpoint = 'app'

export default class AppService {
  config() {
    return axios.get(`/api/${endpoint}/config`).then(res => res.data)
  }
}
